import { Menu, MenuItem } from '@freighthub/silhouette-core'
import { inject } from 'mobx-react'
import { FC, MouseEvent, useState } from 'react'
import { RootStore } from 'service/RootStore'
import { LanguageISO, useI18n } from 'utils/localisation'

interface LanguageSelectMenuItemInject {
  userlaneService: RootStore['userlaneService']
}

interface LanguageSelectMenuItemProps extends Partial<LanguageSelectMenuItemInject> {
  onClose: () => void
}

const LeanTopBarMenuLanguageSelect: FC<LanguageSelectMenuItemProps> = ({ onClose, userlaneService }) => {
  const { availableLanguages, current, currentName, setLanguage } = useI18n()
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event: MouseEvent<HTMLLIElement>) => {
    // @ts-expect-error TS(2345) FIXME: Argument of type 'EventTarget & HTMLLIElement' is ... Remove this comment to see the full error message
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
    onClose()
  }

  const handleClickLanguage = (language: LanguageISO) => {
    setLanguage(language)
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    userlaneService.changeLanguage(language)
    handleClose()
  }

  return (
    <MenuItem onClick={handleClick} cascaded>
      {currentName}
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        width="auto"
      >
        {availableLanguages.map((language) => (
          <MenuItem
            key={language.code}
            value={language.code}
            onClick={() => handleClickLanguage(language.code)}
            selected={current === language.code}
          >
            {language.name}
          </MenuItem>
        ))}
      </Menu>
    </MenuItem>
  )
}

const injector = inject(
  (ctx: RootStore): LanguageSelectMenuItemInject => ({
    userlaneService: ctx.userlaneService,
  })
)

export const TopBarMenuLanguageSelect = injector(LeanTopBarMenuLanguageSelect)
